import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import CSSBuyArticlePage from "../pages/articles/cssbuy/page";
import SuperbuyArticlePage from "../pages/articles/superbuy/page";
import SafetyArticlePage from "../pages/articles/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul-kakobuy-sheet",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CSSBuyArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuyArticlePage />,
  },
  {
    path: "/poradnik-bezpieczenstwa",
    element: <SafetyArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;